import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWebflowComponent } from './simple-icons-webflow.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWebflowComponent ],
    exports:      [ SimpleIconsWebflowComponent ],
    bootstrap:    []
})
export class SimpleIconsWebflowModule {}
